import { useMemo } from "react";
import { useQueryParams } from "../contexts";
import { Entity, ParamsApi } from "../models";

export const useParamsApi = (entity: Entity): ParamsApi => {
    const { getParamsApi } = useQueryParams();
    return useMemo(() => getParamsApi(entity), [entity, getParamsApi]);
};
